import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/login-side-banner.webp'


const _withScopeId = n => (_pushScopeId("data-v-63842726"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-page login-page__prazdroj" }
const _hoisted_2 = { class: "login-page__content" }
const _hoisted_3 = { class: "login-page__header" }
const _hoisted_4 = { class: "asahi-logo-header" }
const _hoisted_5 = { class: "language-dropdown" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "login-container-wrapper",
  id: "login-container"
}, null, -1))
const _hoisted_7 = { class: "login-page__footer" }
const _hoisted_8 = { class: "login-page__footer-title" }
const _hoisted_9 = { class: "login-page__footer-text" }
const _hoisted_10 = { class: "d-flex justify-content-center" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-page__banner" }, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"width":"100%","height":"1090px","object-fit":"cover","display":"block"},
    src: _imports_0,
    alt: "Login page banner"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AsahiLogoNew = _resolveComponent("AsahiLogoNew")!
  const _component_AsahiLanguageSelector = _resolveComponent("AsahiLanguageSelector")!
  const _component_AsahiTypography = _resolveComponent("AsahiTypography")!
  const _component_AsahiButton = _resolveComponent("AsahiButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_AsahiLogoNew)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_AsahiLanguageSelector, {
            languages: _ctx.languages,
            activeLanguage: _ctx.activeLanguage ??= 'en',
            onLanguagechange: _cache[0] || (_cache[0] = (event) => _ctx.changeLanguage(event))
          }, null, 8, ["languages", "activeLanguage"])
        ])
      ]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_AsahiTypography, {
            type: "headline-main",
            class: "primary-white"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Become a partner')), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t(
              'Prazdroj portal is a tool where you can find everything essential for your cooperation with Plzeňský Prazdroj.'
            )), 1),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_AsahiButton, {
            type: "white",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$navigate('/contact'))),
            class: "partner-button"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Contact us')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _hoisted_11
  ]))
}